import { createContext, useContext } from "react";

export const DialogContentContext = createContext<{ divided: boolean }>({ divided: false });

export const useDialogContentContext = () => useContext(DialogContentContext);
